import { render, staticRenderFns } from "./FormDispatch.vue?vue&type=template&id=b0cdd516&"
import script from "./FormDispatch.vue?vue&type=script&lang=ts&"
export * from "./FormDispatch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports